import { mpx } from '@didi/es-mpx-creator'
import { getTrainOrderDetail } from '@/api/order-detail/index'

export default {
  getTrainOrderDetail ({state, commit}, options) {
    if (!options.silenceLoading) {
      mpx.showLoading()
    }
    return getTrainOrderDetail(options).then(res => {
      const {data, code} = res
      if (data || code == '0') {
        commit('setTrainOrderDetail', {...data})
        return data
      }
    }).finally(() => {
      if (!options.silenceLoading) {
        mpx.hideLoading()
      }
    });
  }
}
